import {DefaultPaginationInfo} from "../../../../../../core/constants/enums";
import {CompetitorPriceReportsDataGridColumnNames} from "../../../../../../core/constants/table/data-grid-column-keys";

const col = CompetitorPriceReportsDataGridColumnNames;

export const competitorPriceReportsSortPropertyByColumn = {
    [col.operator]: 'Operator',
    [col.partNumber]: 'Part',
    [col.price]: 'Price',
    [col.competitor]: 'Competitor',
    [col.submitDateTime]: 'SubmitDateTime',
    [col.customer]: 'Customer',
    [col.priceLevel]: 'PriceLevel',
    [col.checked]: 'HasChecked',
    [col.checkedDateTime]: 'CheckedDateTime',
};

export const defaultCompetitorPriceReportsOrderBy = {
    field: col.submitDateTime,
    descending: true,
};

/**
 * Builds the ListPriceReports / ListMyPriceReports request body.
 * Locked ids from a context dialog override matching filter values.
 *
 * @param {object} args
 * @param {{partId?: number, priceLevelId?: number, operatorId?: string|number}} [locked]
 * @return {object}
 */
export const buildCompetitorPriceReportsListRequest = (args, locked = {}) => {
    const filters = args.filters ?? {};
    const sorts = args.orderBy?.field && competitorPriceReportsSortPropertyByColumn[args.orderBy.field]
        ? [{property: competitorPriceReportsSortPropertyByColumn[args.orderBy.field], isDesc: !!args.orderBy.descending}]
        : [];
    const period = (filters.startDate || filters.endDate)
        ? {
            startDateTime: filters.startDate ?? null,
            endDateTime: filters.endDate ?? null,
        }
        : null;
    const isChecked = typeof filters.isChecked === 'boolean'
        ? filters.isChecked
        : typeof filters.hasChecked === 'boolean'
            ? filters.hasChecked
            : null;
    return {
        priceLevelId: locked.priceLevelId ?? filters.priceLevelId ?? null,
        partId: locked.partId ?? (filters.part?.id ? Number(filters.part.id) : null),
        competitorId: filters.competitor?.id ?? null,
        customerId: filters.customer?.id ?? null,
        operatorId: locked.operatorId ?? filters.operator?.id ?? null,
        period,
        hasChecked: isChecked,
        pagination: {
            currentPage: args.paginationInfo?.currentPage ?? 1,
            pageSize: args.paginationInfo?.pageSize ?? DefaultPaginationInfo.pageSize,
        },
        sorts,
    };
};
